/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./grant.defs.js";
export { main as default } from "./grant.defs.js";
